import { createContext } from "react";

export const ImportantVisitContext = createContext<boolean>(false);
